export const KNOTS_PLATFORM_URL = process.env.REACT_APP_PLATFORM_URL || 'http://localhost:3000'
export const CODE_APP_API_URL = (process.env.REACT_APP_CODE_APP_API_URL as string) || 'http://localhost:3002'
export const CODE_APP_API_EXPOSED_ROUTE_URL =
  (process.env.REACT_APP_API_EXPOSED_ROUTE_URL as string) || 'http://localhost:3002/r'
export const API_URL = (process.env.REACT_APP_API_URL as string) || 'http://localhost:3000'
export const CF_API_URL = (process.env.REACT_APP_CF_API_URL as string) || 'http://localhost:3000'
export const PUBLIC_URL = (process.env.REACT_APP_PUBLIC_URL as string) || 'http://localhost:3010'
export const BUILD_NUMBER = (process.env.REACT_APP_BITBUCKET_BUILD_NUMBER as string) || 'dev'
export const GOOGLE_OAUTH_CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID as string
export const INBOUND_EMAIL_DOMAIN = process.env.REACT_APP_INBOUND_EMAIL_DOMAIN as string
export const defaultUtmSource = 'studio'